import { useRootSelector } from '../../hooks/root-selector.hook';
import { DataTestId } from './DataTestId';

export const PageDataTestId = (): React.ReactElement => {
    const pathname = useRootSelector(state => state.router.location.pathname);
    return <DataTestId id={pathname} />;
};
